import { Component, input, output } from '@angular/core';
import { InfiniteScrollCustomEvent } from '@ionic/angular';
import { BookingVendorListResponse } from 'src/app/models/request-service.model';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.scss'],
  standalone: false
})
export class VendorListComponent {
  vendors = input<BookingVendorListResponse[]>([]);
  canScheduleAppt = input<boolean>(false);
  isServiceSelected = input<boolean>(false);
  hasMoreData = input<boolean>(false);
  srcPath = input<string | null>(null);

  loadMore = output<InfiniteScrollCustomEvent>();
  saveVendor = output<BookingVendorListResponse>();
  callHolman = output<string>();
  navigateVendor = output<BookingVendorListResponse>();

  constructor() { }

  preferredGarages(vendor: BookingVendorListResponse) {
    let classes = {}
    if (vendor.vendoR_TYPE === 'Primary') {
      classes = {
        primaryVendor: true,
      };
    }
    else if (vendor.vendoR_TYPE === 'Secondary') {
      classes = {
        secondaryVendor: true,
      };
    }
    else if (vendor.vendoR_TYPE === 'Tertiary') {
      classes = {
        tertiaryVendor: true,
      };
    }
    return classes;
  }
}
